module.exports = __webpack_public_path__ + "img/1997_S.bae3f22d.png";